<template>
	<!-- <div id="faq"> -->
		<div class="faq">
			<div class="faq_content container">

				<div class="accordion_wrapper">
					<div class="accordion">
						<div class="accordion" id="accordionFaq">
							<div
							class="accordion-item"
							v-for="item in accordionItems"
							:key="item.id"
							>
							<template v-if="item.header == 'Half-Season Plan FAQ’s'">
								<h3 class="sub_header">Half-Season Plan</h3>
							</template>
							<template v-else>
								<div>
									<h2 class="accordion-header">
										<button
										class="accordion-button collapsed"
										type="button"
										data-bs-toggle="collapse"
										:data-bs-target="`#${item.id}`"
										>
											<h3>{{ item.header }}</h3>
										</button>
									</h2>

								<div
									:id="item.id"
									class="accordion-collapse collapse"
									:class="!item.collapse || 'show'"
									data-bs-parent="#accordionFaq"
									>
									<div class="accordion-body">
										<div v-if="item.header == 'WHAT EXTRA BENEFITS CAN I EXPECT AS A SEASON TICKET HOLDER?'">
											<p class="menu-item" v-scroll-to="benefitLink" >As a member of our Cubs Season Ticket Holder Family, you’ll enjoy numerous exclusive benefits. Please visit the <a href="#benefits">"Exclusive Benefits"</a> section above for detailed information on the benefits of being a Cubs Season Ticket Holder.</p>
										</div>
										<div v-else-if="item.header == 'HOW DOES PRICING DIFFER BETWEEN THE FULL-SEASON “DAILY PLAN” AND HALF-SEASON PLAN?'" >
											<p class="menu-item" v-scroll-to="pricingLink" >Pricing is higher on a per-game basis for the Half-Season Plan than the same seating location chosen in a Daily Plan. Please review the <a href="#account_summary">"Plans and Pricing"</a> section for more information on pricing.</p>
										</div>
										<div v-else-if="item.header == 'WHAT BENEFITS ARE OFFERED TO HALF-SEASON PLAN SEASON TICKET HOLDERS?'" >
											<p class="menu-item" v-scroll-to="pricingLink" >To view the benefits associated with Half-Season plans, please review the <a href="#account_summary">“Plans and Pricing”</a> section.</p>
										</div>
										<div v-else class="faq_text" v-html="$sanitize(item.body)"></div>
									</div>
								</div>
						</div>
							</template>

				</div>
			</div>
		</div>
	</div>
</div>
</div>

</template>

<script>

export default {
	naem: "Faq",
	data() {
		return {
			benefitLink: "#benefits",
			pricingLink: "#account_summary",
			accordionItems : [
				{
					id: "zero",
					header: "HOW MANY SEASON TICKET SEATS CAN I PURCHASE?",
					body: "You can purchase a maximum of six (6) seats per new season ticket account, pending availability.",
				},
				{
					id: "one",
					header: "CAN I PURCHASE SEASON TICKET SEATS AFTER MY APPOINTMENT?",
					body: "Yes. If you are unable to purchase during your appointment time, your online login capability will remain active until the purchasing deadline. Your appointment time was first emailed to you by your dedicated Cubs Representative the week of December 12.",
				},
				{
					id: "two",
					header: "WHEN IS MY PAYMENT DUE AND WHAT FORMS OF PAYMENT ARE ACCEPTED?",
					body: `When selecting seats, you will have the option to submit full payment or a nonrefundable first payment of 50 percent of your season ticket balance. If you select to submit the 50% nonrefundable first payment, your initial payment must be made via credit card. The credit card(s) applied for the first payment will be auto-debited for the remaining balance due on Wednesday, March 8, 2023.  <br/><br/> We accept all major credit cards.`,
				},
				{
					id: "three",
					header: 'WILL I BE ABLE TO USE MORE THAN ONE CREDIT CARD WHEN SUBMITTING PAYMENT VIA "MY CUBS TICKETS?"',
					body: `Yes. If you'd like to use more than one credit card for your payment, you must select the "Set Up Payment Plan" option at the checkout screen and uncheck the box that says “Use one payment method for all future installments.” Please note you are only able to split payments on a desktop or tablet. The feature to split payment is not available on a mobile device.`
				},
				{
					id: "four",
					header: "ARE THERE OPPORTUNITIES FOR ALL-INCLUSIVE SEASON TICKETS WITH CLUB ACCESS?",
					body: `Yes. For the 2023 season, we will have limited seats available for all-inclusive season tickets with club access. To learn more, please reach out to your dedicated Cubs representative or visit <a class="links" href="https://cubspremier.com/" target="_blank">CubsPremier.com.</a>`,
				},
				{
					id: "five",
					header: "DO I NEED TO VISIT WRIGLEY FIELD TO BUY SEASON TICKETS?",
					body: `While visiting Wrigley Field is a great resource to help select seats, it is not required. You may visit Wrigley Field during your assigned appointment time to compare various locations.  Please note, in the event of inclement weather, certain seating areas and specific seats may be unavailable to attendees. If you are unable to attend, you can utilize our <a class="btn-red" class="links" href="https://map.3ddigitalvenue.com/chicago-cubs" target="_blank">3D Seating Map</a> while purchasing online to understand the view from specific seating locations.<br><br>
					Please note, all seating sections and specific seats may not be available for viewing.`,

				},
				{
					id: "six",
					header: "WHEN WILL I KNOW WHAT SEATS ARE AVAILABLE?",
					body: "You will view available seats when your appointment time begins. Your appointment time will be included in an email sent to you in late December. Seats will sell quickly so we recommend logging in and selecting seats as close to the start of your appointment time as possible.",
				},
				{
					id: "seven",
					header: "WILL ACCESSIBLE SEATING BE AVAILABLE?",
					body: `Yes, pending availability. To view only accessible seating when looking at seating inventory, please check the box "Yes, show me accessible seating" in the search options where it asks, "Do you need accessible seating?"`,
				},
				{
					id: "eight",
					header: "WILL PARKING BE AVAILABLE FOR PURCHASE AS A SEASON PACKAGE?",
					body: "No, parking will not be available in 2023 for new Season Ticket Holders. If interested in parking for future seasons, please notify your dedicated Season Ticket Service Representative who will be assigned to you prior to the start of the season.",
				},
				{
					id: "nine",
					header: "WHAT EXTRA BENEFITS CAN I EXPECT AS A SEASON TICKET HOLDER?",
					body: ``,
				},
				{
					id: "ten",
					header: "WHAT HAPPENS IF I DECLINE MY OPPORTUNITY TO PURCHASE CUBS SEASON TICKETS?",
					body: "If season ticket seats are available and you decline to purchase seats, you will be removed from the Season Ticket Holder Waiting List.",
				},
				{
					id: "eleven",
					header: "HOW AND WHEN WILL I RECEIVE MY 2023 SEASON TICKETS?",
					body: `Season tickets will be available exclusively as mobile tickets via the MLB Ballpark app. We anticipate your mobile tickets will be available beginning in late February 2023. Visit  <a class="links" href="http://www.cubs.com/ballparkapp" target="_blank">www.cubs.com/ballparkapp</a> for more information.
					<br/><br/> To help prevent the unintended or fraudulent resale of your season ticket(s), refrain from sharing images that reveal your ticket's unique barcode letters and numbers. Please note if you do share your barcodes, the Cubs will not be responsible for resulting use by third parties.`,
				},
				{
					id:"twelve",
					header: "HOW DO YOU RECOMMEND SHARING SEASON TICKETS WITH FAMILY AND FRIENDS?",
					body: `Most Season Ticket Holders will allocate their games to family, friends and others in their network. The <a class="links" href="http://www.cubs.com/ballparkapp" target="_blank">MLB Ballpark app</a> and the <a target="_blank" href="https://mpv.tickets.com/?orgid=40490&agency=CBMT_MYTIXX#/auth/login">"My Cubs Tickets"</a> site make it easy to digitally share tickets with your partners.`,
				},
				{
					id:"none",
					header: "Half-Season Plan FAQ’s",
					//body: `Most Season Ticket Holders will allocate their games to family, friends and others in their network. The <a class="links" href="http://www.cubs.com/ballparkapp" target="_blank">MLB Ballpark App</a> and the <a target="_blank" href="https://mpv.tickets.com/?orgid=40490&agency=CBMT_MYTIXX#/auth/login">"My Cubs Tickets"</a> site make it easy to digitally share tickets with your partners.`,
				},
				{
					id:"thirteen",
					header: "WHAT GAMES ARE INCLUDED IN THE 2023 RED AND BLUE HALF-SEASON PLANS?",
					body: `Both plans include Opening Day 2023* with the remaining 80 games split between the two packages (i.e., total of 41 games in each package). Please view the 2023 Red and Blue Half-Season Plan schedules below.<br><br>
					<a style="color:black" href="https://cubs.fanportal-mlb.com/waitlist2023/files/STH%20Renewal_Schedule_Red_2023.pdf">2023 Red Plan (41 games)</a> <br>
					<a class="links" href="https://cubs.fanportal-mlb.com/waitlist2023/files/STH%20Renewal_Schedule_Blue_2023.pdf">2023 Blue Plan (41 games)</a><br><br>
					*Since both half-season packages receive Opening Day, Blue Plan seat(s) may be in a different location within the same price point for that game.<br><br>
					Please note availability for the Half-Season Plan is limited.`,
				},
				{
					id: "fourteen",
					header: "WHAT SEATING LOCATIONS ARE OFFERED FOR THE RED AND BLUE PLANS?",
					body: `The following seating locations are offered for Red and Blue Half-Season Plans.<br><br>
							<ul>
								<li>Field Box Outfield</li>
								<li>Terrace Reserved Outfield</li>
								<li>Upper Box Midfield</li>
								<li>Upper Box Outfield</li>
							</ul>
							Please note seats and locations are subject to availability.
					`,
				},
				{
					id: "fifteen",
					header: "HOW DOES PRICING DIFFER BETWEEN THE FULL-SEASON “DAILY PLAN” AND HALF-SEASON PLAN?",
					body: ``,
				},
				{
					id: "sixteen",
					header: "WHAT IS THE DIFFERENCE IN POSTSEASON TICKET ACCESS BETWEEN THE DAILY PLAN AND HALF-SEASON PLAN?",
					body: `Daily Plan Season Ticket Holders have the opportunity to purchase tickets for all postseason games at Wrigley Field. <br><br>
					Half-Season Plan Season Ticket Holders will have the opportunity to purchase one game per round of the Wild Card (if hosted by Cubs), NLDS, NLCS and World Series.<br><br>
					Please note pricing for postseason games will be communicated to Season Ticket Holders in advance of postseason play and any purchase opportunities.`,
				},
				{
					id: "seventeen",
					header: "WHAT BENEFITS ARE OFFERED TO HALF-SEASON PLAN SEASON TICKET HOLDERS?",
					body: `To view the benefits associated with Half-Season plans, please review the “Plans and Pricing” section.`
					// body: `Half-Season Plan Season Ticket Holders have access to select benefits and seating options. Please review the "Plans and Pricing" section for the detailed list of benefits.`,
				},
				{
					id: "eighteen",
					header: "CAN I REQUEST DIFFERENT GAMES THAN THOSE PROVIDED IN THE 2023 RED OR BLUE HALF-SEASON PLANS?",
					body: "Half-Season Plans are sold as is and cannot be adjusted.",
				},
				{
					id: "nineteen",
					header: "IN THE FUTURE, CAN I SWITCH BETWEEN RED AND BLUE HALF-SEASON PLANS?",
					body: "Yes, pending availability. During the annual relocation process, you have the opportunity to review available seating locations for the other half-season plan and can select to switch to that plan. Please note adjusting plans may require a new seating location.",
				},
				{
					id: "twenty",
					header: "IN THE FUTURE CAN I UPGRADE FROM A HALF-SEASON PLAN TO A FULL-SEASON PLAN?",
					body: "Yes, pending availability. During the annual relocation process, you have the opportunity to review available seating locations for the Daily Plan and can select to upgrade to the Daily Plan. Please note adjusting plans may require a new seating location",
				},


			],
		};
	},

};
</script>

<style lang="scss" scoped>
a{
	color: #474747 !important;
}
.faq {

	display: flex;
	position: relative;
	width:100%;
	&_content {
		 // align-items: center;
		// margin-block: 15vh;
		@include media-breakpoint-down(sm) {
			// margin-block: 5vh;
		}
		z-index: 1;
		@include media-breakpoint-up(xl) {
			// max-width: 890px;
		}
		h1 {
			// font-family: "AntaTrial-UltExpExtBd";
			font-size: 30px;
			color: theme-var($--ch-theme-primary);
			letter-spacing: 0;
			text-align: center;
			font-weight: 900;
		}
		.sub_header{
			color: theme-var(--ch-theme-secondary);
			font-size: 30px;
			font-family: 'Verlag Condensed Black';
			text-transform:uppercase;
			margin: 30px 0px;
		}
		.accordion {
			width:100%;
			&_wrapper {
				// margin-top: 50px;
			}
			&-item {
				margin-bottom: 20px;
				border-radius: none;
				// background:white;
				// box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
				border:  none;
				background-color: transparent;
				//width: 1060px;
				&:last-of-type {
					border-radius: 0 !important;
					.accordion-collapse {
						border-radius: 0 !important;
					}
				}
				&:first-of-type {
					border-radius: 0 !important;
					.accordion-collapse {
						border-radius: 0 !important;
					}
				}
			}
			&-body{
				margin: 0px 10px;
				background:white;
				font-family: 'Verlag Book';
				font-style: normal;
				font-weight: 325;
				font-size: 16px;
				line-height: 145%;
				color: #474747;
				padding: 15px 15px 10px 30px;
				@include media-breakpoint-down(sm) {
					font-size: 12px;
				}
				.faq_text{
					color: #474747 !important;
					a{
						font-size:19px;
						color: #474747 !important;
					}
				}
			}

			h2{
				position:relative;
			}

			&-button {
				outline: none !important;
				// font-family: "AntaTrial-Bold";
				// color: white;
				box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.2);
				background:white;
				border-radius: none;
				border:none;
				padding: 15px 15px 10px 30px;
				&:focus {
					border-color: none;
					box-shadow: none;
				}

				&::after {
					position:absolute;
					right:20px;
					top:0%;
					flex-shrink: 0;
					width: 1.25rem;
					height: 1.25rem;
					// margin-left: auto;
					content: url("~images/icons/faq_downArrow.svg");
					background-image: revert;
					transform: translate(0px ,50%);
					// transition: transform 0.2s ease-in-out;
				}
				&.collapsed {
					background: white;
					h3 {
						color: theme-var($--ch-theme-primary);
					}
					&::after {
						// content: url("~images/icons/faq_upArrow.svg");
						// transform: rotate(0deg);
						// transition: transform 0.2s ease-in-out;
					}
				}
				&:not(collapsed) {
					background:theme-var($--ch-theme-primary);
					h3 {
						color: white;
					}
					&::after {
						// content: url("~images/icons/faq_downArrow.svg");
						// transform: rotate(-180deg);
						// transition: transform 0.2s ease-in-out;
						// faq_downArrow.svg
						// faq_upArrow.svg
					}
				}

				h3 {
					font-family: 'Verlag';
					font-style: normal;
					font-weight: 350 !important;
					font-size: 16px;
					line-height: 145%;
					// font-family:  ;
					margin-right: 20px;
					text-transform:uppercase;
					@include media-breakpoint-down(sm) {
						font-size: 12px;
					}

					// span {
					// 	font-family: "Helvetica", "Arial", sans-serif !important;
					// 	font-size: 22px;
					// }
				}
			}
		}
	}
}
</style>
